import React from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import FontAwesome from 'react-fontawesome';
import {Button} from 'reactstrap';
import './DateRangePicker.css';
import {labels} from "../../util/constants";
import {generalConfig} from "../../util/config";

const DataRangePicker = (props) =>{
    var start = props.startDate.format(generalConfig.dateFormat);
    var end = props.endDate.format(generalConfig.dateFormat);

    return (
        <DateRangePicker singleDatePicker={props.oneDate} startDate={props.startDate} endDate={props.endDate} maxDate={props.maxDate}
                          ranges={props.ranges} onEvent={props.handleEvent} minDate={props.minDate}
                          alwaysShowCalendars = {true} autoApply = {true} onCancel={()=> props.cancelAction ? props.cancelAction() : {}}
                          locale={{
                              customRangeLabel: labels.customRangeLabel, format: generalConfig.dateFormat, applyLabel: labels.applyLabel,cancelLabel: labels.cancelLabel,
                              monthNames: labels.monthNames, daysOfWeek: labels.daysOfWeek
                          }} >
            <Button className="selected-date-range-btn btn-date-picker" >
                <div className="pull-left"><FontAwesome name='calendar'/> </div>
                <div className="pull-center">
                    {props.oneDate  ? <span>{start}</span> : <span>{start}&nbsp;&nbsp; <FontAwesome name='arrow-right'/> &nbsp;&nbsp;{end}</span>}

                    <span className="pull-right"><FontAwesome name='caret-down'/></span>
                </div>
            </Button>
        </DateRangePicker>
    );
}

export default DataRangePicker;


// WEBPACK FOOTER //
// ./src/components/DatePickerComponent/DateRangePicker.js